import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Avatar} from 'antd';
import styles from './index.module.less';

export default function WeappCard({weapp}) {
    console.log('webapp', weapp);
    let {displayname, title} = weapp;
    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <Avatar src={require('@/asset/weapp.png')} className={styles.avatar} />
                <div className={styles.title}>{title}</div>
            </div>
            <Divider style={{margin: '20px 0'}} />
            <div className={styles.foot}>{displayname}</div>
        </div>
    );
}

WeappCard.propTypes = {
    weapp: PropTypes.object,
};
